( function( global, $ ) {
    "use strict";

    var _events = {
        onChangeCountry: function(ev) {
            ev.preventDefault();

            var $this = $(this),
                $target = $($this.attr('data-subdivision-target')),
                $fallback = $($this.attr('data-subdivision-fallback')),
                $form = $(this.form),
                country = $this.val();

            $fallback.val('');

            // Clean subdivisions select
            $target.html('');

            if (! country || $form.is('[data-form-autosubmit]')) {
                return;
            }

            $.App.api('GET', 'countries/' + country).done(function(data) {
                if (data.subdivisions) {
                    var $targetFormGroup = $target.closest('.gr-form__field');
                    var $label = $targetFormGroup.find('[for="'+$target.attr('id')+'"]');

                    $label.text(data.subdivisions_single_name);

                    $fallback.closest('.gr-form__field').addClass('hidden');
                    $targetFormGroup.removeClass('hidden');

                    $('<option />').appendTo($target);
                    $.each(data.subdivisions, function(value, label) {
                        $('<option />')
                            .attr('value', value)
                            .text(label)
                            .appendTo($target);
                    });

                    if ($target.get(0).selectize) {
                        var selectize = $target.get(0).selectize;

                        var options = [];
                        $target.find('option').each(function() {
                            var $option = $(this);
                            options.push({text:$option.text(), value:$option.val()})
                        });

                        selectize.clear();
                        selectize.clearOptions();
                        selectize.renderCache['option'] = {};
                        selectize.renderCache['item'] = {};

                        selectize.addOption(options);
                    }
                } else {
                    $target.closest('.gr-form__field').addClass('hidden');
                    $fallback.val('')
                        .closest('.gr-form__field').removeClass('hidden');
                }
            });
        },

        onChangeSubdivisionCode: function(ev) {
            ev.preventDefault();

            var $this = $(this),
                $fallback = $($this.attr('data-subdivision-fallback'));

            $fallback.val('');
        }
    };

    $('body').on('app.init', function(ev) {
        var $container = $(ev.container);

        $container.find('[data-country]').on('change', _events.onChangeCountry);
        $container.find('[data-subdivision-code]').on('change', _events.onChangeSubdivisionCode);
    });

}( window.groots, jQuery ));
